import { SearchDto } from './search.dto';
import { FileDto } from './file.dto';
import { ReactElement } from 'react';

/**
 * DTO du formulaire de recherche pour les propositions d'affectations
 */
export interface ProposalsAssignmentsFormDto {
    // reference
    reference?: string;
    // codeTBB
    codeTBB?: string;
    // Nom
    name?: string;
    // Lieu
    place?: string;
}

/**
 * DTO du formulaire de recherche pour les interventions
 */
export interface InterventionsFormDto {
    // numero
    reference?: string;
    // codeTBB
    codeTBB?: string;
    // Nom
    name?: string;
    // Lieu
    place?: string;
    // Date planifiée
    plannedDate?: string;
    // Date de réalisation
    realisationDate?: string;
    // Etat
    state?: InterventionState | string;
}
/**
 * DTO du envoyer les paramètres en API pour les propositions d'affectations à valider
 */
export interface SearchProposalAssignmentsDto extends SearchDto<ProposalAssignmentDto> {
    // reference
    paramReference?: string;
    // codeTBB
    paramcodeTBB?: string;
    // Nom
    paramName?: string;
    // Lieu
    paramPlace?: string;
}

/**
 * DTO du envoyer les paramètres en API pour les propositions d'affectations à valider
 */
export interface SearchInterventionsDto extends SearchDto<InterventionDto> {
    // Numero
    paramReference?: string;
    // codeTBB
    paramcodeTBB?: string;
    // Nom
    paramName?: string;
    // Lieu
    paramPlace?: string;
    // Date planifiée
    paramPlannedDate?: string;
    // Date de réalisation
    paramRealisationDate?: string;
    // Etat
    paramState?: InterventionState | string;
    // document associé
    document?: {
        // document associé
        file?: string;
        // document associé
        fileName?: string;
    };
    finalDoc?: FileDto;
}

/**
 * DTO des interventions
 */
export interface ProposalAssignmentDto {
    // identifiant de l'intervention dans Sortie
    sortieId?: number;
    // numero
    reference?: string;
    // codeTBB
    codeTBB?: string;
    // Nom
    name?: string;
    // Lieu
    place?: string;
    // sous proposition d'affectation
    accepted?: boolean;
    // Le PDF contient le repère nécessaire à la signature électronique
    electronicSignatureAvailable?: boolean;
    // document associé
    document?: {
        // document associé
        file?: string;
        // document associé
        fileName?: string;
    };
    finalDoc?: FileDto;
}

/**
 * DTO des interventions
 */
export interface InterventionDto {
    // numero
    reference?: string;
    // codeTBB
    codeTBB?: string;
    // Nom
    name?: string;
    // Lieu
    place?: string;
    // Date planifiée
    plannedDate?: string;
    // Date de réalisation
    realisationDate?: string;
    // Etat
    state?: InterventionState | string;
    // Etat
    stateToShow?: ReactElement<any, any>;
    // sous proposition d'affectation
    underProposalAssignment?: boolean;
    // document associé
    document?: {
        // document associé
        file?: string;
        // document associé
        fileName?: string;
    };
    finalDoc?: FileDto;
}

/**
 * Enum pour le type d'indicateurs
 */
export enum InterventionState {
    //Non planifiée
    NO_PLANNED = 'Non planifiée',
    //Planifiée
    PLANNED = 'Planifiée',
    //Terminée
    FINISHED = 'Terminée',
}
